import { render } from "./EditResidentDetails.vue?vue&type=template&id=57e010df&scoped=true"
import script from "./EditResidentDetails.vue?vue&type=script&lang=js"
export * from "./EditResidentDetails.vue?vue&type=script&lang=js"

import "./EditResidentDetails.vue?vue&type=style&index=0&id=57e010df&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e010df"]])

export default __exports__